'use strict'

define [], () ->
  (RENTAPPLICATION_API_URL, RentappService, Experian) ->
    restrict: "E"
    template: require("./smartmove.jade")
    scope:
      reportSourceProfiles: "="
    link: (scope, element, attrs) ->


// WEBPACK FOOTER //
// ./directives/rspSignupPrompts/report_source_profiles/smartmove/smartmove.coffee